// extracted by mini-css-extract-plugin
module.exports = {"navStyle":"Navbar_navStyle__1g9ER","list":"Navbar_list__3Amyw","link":"Navbar_link__2gvb6"};